import { AbstractReportPmsApiService } from '../abstract-report.service';
import { Occupancy } from '../../../models/reports/production/occupancy.model';

/**
 * @class OccupancyPmsApiService
 * @extends {AbstractReportPmsApiService<Occupancy>}
 */
export class OccupancyPmsApiService extends AbstractReportPmsApiService {

    /**
     * @type {string}
     * @protected
     */
    get urlPattern() {

        return super.urlPattern + '/production/occupancy';
    }

    /**
     * @param {Object.<string, *>} attributes
     * @returns {Occupancy}
     * @protected
     */
    newModel(attributes, ...params) {

        return new Occupancy(attributes);
    }

    /**
     * @param {Object=} params
     * @param {Property=} property
     * @returns {Promise.<Occupancy[]>}
     */
    getGraphData(params = {}, property = null) {

        const url = this.url({propertyId: property ? property.id : 0});

        return this.http
            .post(url, params, {
                headers: this.authHeaders,
            })
            .then(this.getDataExtractor())
            .catch(this.getErrorHandler());
    }
}



// WEBPACK FOOTER //
// ./src/pms-api/services/reports/production/occupancy.service.js